import { Component, OnInit, Input } from '@angular/core';
import { UtilService } from '../../shared/util/util.service';
import { TimeZoneService } from '../shared/time-zone/time-zone.service';
import { TimeZone } from '../shared/time-zone/time-zone.model';
import { NumberValueAccessor, CreateNumberValueAccessorProvider } from '../../shared/widgets/value-accessors/number-value-accessor';

@Component({
  selector: 'wl-time-zone-selector',
  templateUrl: 'time-zone-selector.component.html',
  styleUrls: ['time-zone-selector.component.css'],
  providers: [CreateNumberValueAccessorProvider(TimeZoneSelectorComponent)],
  standalone: false
})
export class TimeZoneSelectorComponent extends NumberValueAccessor implements OnInit {
  public _timeZoneService: TimeZoneService;
  public _utilService: UtilService;

  public timeZones: Array<TimeZone>;
  public constructor(utilService: UtilService, timeZoneService: TimeZoneService) {
    super();
    this._utilService = utilService;
    this._timeZoneService = timeZoneService;
    this.timeZones = new Array<TimeZone>();
  }

  ngOnInit() {
    this._timeZoneService.getTimeZones().then((data: Array<TimeZone>) => {
      this.timeZones = data;
    });

    if (this._utilService.isNullOrLessThanOrEqualToZero(this.value)) {
      //get default time zone
      this._timeZoneService.getDefaultTimeZone().then((data: TimeZone) => {
        if (this._utilService.isNullOrLessThanOrEqualToZero(this.value)) {
          this.value = data.UniqueId;
        }
      });
    }
  }
}
